import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import './styles/modalLanguagesLive.css';
import MultipleLangLive from '../../AAF/LanguageLive/MultipleLangLive';

const ModalLanguagesLive = (props = {}) => {
  let parseButton = [];

  let timerCoverFlow = setTimeout(() =>{
    props.handleClose();
  }, MultipleLangLive.geTimerModalHide());
  
  const resetTimerModalLang = function (){
    clearTimeout(timerCoverFlow);
    timerCoverFlow = setTimeout(() =>   props.handleClose(),  MultipleLangLive.geTimerModalHide());
  }
  
  // const defaultLanguage = DeviceStorage.getItem('default_lang') || false;
  const renderButtons = (buttons = [], isAudio) => {
    return buttons.map((button, i) => {
      const defaultItem = 'modal-default-item';
      const extraClass = button.extraClass ? button.extraClass : '';
      const bid = (isAudio ? 'audio_' : 'text_') + 'live_' + i;
      return <a
        style={button.styles}
        className={`modal-button focusable ${extraClass} ${button.selected ? defaultItem : ''}`}
        // key={button.id}
        id={bid}
        {...button.props}
        href="javascript:void(0)">
        {button.content} {button.selected && <i className="fa fa-check" aria-hidden="true" />}
      </a>
    })
  }
  

  const setSelectedItem = function (isAudio, it) {
    const whereFind = isAudio ? 'modal-select-live-lang-audio-options' : 'modal-select-live-lang-text-options';
    const subs_icons = document.getElementsByClassName(whereFind);
    if (subs_icons) {
      [...subs_icons[0].children].map((item) => {
        // Se quita la palomita de "selected"
        var unchecked = item.innerHTML.replace(/(<([^>]+)>)/ig, "");
        item.innerHTML = unchecked;
      });
    }
    // Se mantiene la palomita en donde se tenga que mantener
    let flt = null;
    if (isAudio) {
      flt = props.languages.audio.findIndex(opt => opt.option_id === it.option_id);
    }
    else {
      flt = props.languages.subtitles.findIndex(opt => opt.option_id === it.option_id);
    }
    if (!isNaN(flt)) {
      const selected_opt = document.getElementById((isAudio ? 'audio_live_' : 'text_live_') + flt);
      if (selected_opt) {
        selected_opt.innerHTML = selected_opt.innerHTML + ' <i class="fa fa-check" aria-hidden="true" />';
      }
    }
  };

  let audio_options = Translator.get('btn_modal_live_lang_no_available', 'No disponible');
  let text_options = Translator.get('btn_modal_live_lang_no_available', 'No disponible');

  if (props.languages) {
    if (props.languages && props.languages.audio && Array.isArray(props.languages.audio)) {
      if (props.languages.audio.length > 0) {
        const defaultLanguage = DeviceStorage.getItem('default_lang_audio_live') || false;
        props.languages.audio.map((it, i) => {
          parseButton.push({
            content: it.label_large,
            selected: (defaultLanguage && (typeof defaultLanguage == 'string') && (typeof it.option_id == 'string') && (defaultLanguage.toUpperCase() == it.option_id.toUpperCase())) ? true : false,
            props: {
              onClick: (e) => {
                setSelectedItem(true, it);
                props.callback(true , it);
                if(MultipleLangLive.isEnableCloseOnClick()){
                  props.handleClose(e);
                }
              }
            }
          });
        });
        audio_options = renderButtons(parseButton, true);
        parseButton = [];
      }
    }
    
    if (props.languages && props.languages.subtitles && Array.isArray(props.languages.subtitles)) {
      if (props.languages.subtitles.length > 0) {
        const defaultLanguage = DeviceStorage.getItem('default_lang_subtitle_live') || false;
        props.languages.subtitles.map((it, i) => {
          parseButton.push({
            content: it.label_large,
            selected: (defaultLanguage && (typeof defaultLanguage == 'string') && (typeof it.option_id  == 'string')  && (defaultLanguage.toUpperCase() == it.option_id.toUpperCase())) ? true : false,
            props: {
              onClick: (e) => {
                setSelectedItem(false, it);
                props.callback(false , it);
                if(MultipleLangLive.isEnableCloseOnClick()){
                  props.handleClose(e);
                }
              }
            }
          });
        });
        text_options = renderButtons(parseButton, false);
        parseButton = [];
      }
    }

  }
  else {
    parseButton.push({ //ToDo Harcodeo para caso de nvrp, ya que getmedia no nos da ningun lenguaje
      content: 'Idioma Original',
      selected: true,
      props: {
        onClick: (e) => props.handleClose(e),
      }
    });
  }


  const modalProps = {
    buttons: [{
      buttonsAlign: 'vertical',
      content: Translator.get('button_live_audio_subtitle_exit', MultipleLangLive.nameTagTemp('button_live_audio_subtitle_exit')),
      props: {
        onClick: (e) => {
          props.handleClose(e);
        }
      }
    }],
    timer: () => {
      resetTimerModalLang();
    }
  };



  return <ModalWrapper {...modalProps}>
    <div className={"modal-select-live-lang"}>
      <div className={"modal-select-live-lang-audio-title"}>{Translator.get('title_live_audio', MultipleLangLive.nameTagTemp('title_live_audio'))}</div>

      <div className={"modal-buttons-vertical modal-select-live-lang-audio-options"}>
        {audio_options}
      </div>

      <div className={"modal-select-live-lang-text-title"}>{Translator.get('title_live_subtitle', MultipleLangLive.nameTagTemp('title_live_subtitle'))}</div>
      <div className={"modal-buttons-vertical modal-select-live-lang-text-options"}>
        {text_options}
      </div>
    </div>
  </ModalWrapper>
}

export default withOnClose(ModalLanguagesLive);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalLanguagesLive.jsx